import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Location } from '@angular/common';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { EntityContainer } from 'src/app/tools/models/entityContainer';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { AssetService } from '../../services/asset-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { AssetPipe } from '../../pipes/asset-pipe';
import { Asset } from 'src/app/assabil-kernel/models/entities/master-data/asset';
import { AssetStatus } from 'src/app/assabil-kernel/models/entities/control-tables/asset-status';
import { Branch } from 'src/app/assabil-kernel/models/entities/control-tables/branch-entity';
import { AssetProductCategory } from 'src/app/assabil-kernel/models/entities/control-tables/asset-product-category-entity';
import { AssetProduct } from 'src/app/assabil-kernel/models/entities/control-tables/asset-product-entity';
import { BranchLovComponent } from 'src/app/assabil-admin/components/control-tables/branch/branch-lov/branch-lov.component';
import { AssetProductLov } from '../asset-product-lov/asset-product-lov.component';
import { AssetProductCategoryLovComponent } from '../asset-product-category-lov/asset-product-category-lov.component';
import { Field } from 'src/app/tools/models/dtos/field';


@Component({
    selector: 'asset-list',
    templateUrl: './asset-list.component.html',
    styleUrls: ['./asset-list.component.scss']
})


export class AssetListComponent extends BasePage2<Asset> {

    branchLovComponent               = BranchLovComponent;
    assetProductCategoryLovComponent = AssetProductCategoryLovComponent;
    assetProductLov                  = AssetProductLov;

    assetStatuses   : AssetStatus[] = [];

    id                   : number;
    assetStatusCode      : string;
    name                 : string;
    rank                 : number;
    assetPipe            : AssetPipe = new AssetPipe();

    assets          : Asset[] = [];
    barCode         : string;
    serialNumber    : string;
   
    branch                  : Branch                = new Branch();
    assetProductCategory    : AssetProductCategory  = new AssetProductCategory();
    assetProduct            : AssetProduct          = new AssetProduct();
    assetStatus             : AssetStatus           = new AssetStatus();
    withPendingTickets      : boolean               = true;
    withoutPendingTickets   : boolean               = true;
    includeClosed           : boolean               = false;
    

    constructor(
        protected toastr            : ToastrService,
        protected assetService      : AssetService,
        protected router            : Router,
        protected baseService       : BaseService,
        protected leanUtilsService  : LeanUtilsService, 
        protected location          : Location) {
         super(toastr, router, baseService, leanUtilsService, location);

         this.entityName = 'asset';

        let ast : AssetStatus;
        

        ast = new AssetStatus();
        ast.assetStatusCode = "Available";
        ast.name = "Disponible";
        this.assetStatuses.push(ast);

        ast = new AssetStatus();
        ast.assetStatusCode = "PendingFromSupplier";
        ast.name = "Instance fournisseur";
        this.assetStatuses.push(ast);

        ast = new AssetStatus();
        ast.assetStatusCode = "PendingToBranch";
        ast.name = "Instance Transfert Agence";
        this.assetStatuses.push(ast);

        ast = new AssetStatus();
        ast.assetStatusCode = "Instance déploiement";
        ast.name = "";
        this.assetStatuses.push(ast);

        ast = new AssetStatus();
        ast.assetStatusCode = "PendingFromPartner";
        ast.name = "Instance retour";
        this.assetStatuses.push(ast);

        ast = new AssetStatus();
        ast.assetStatusCode = "Decommissioned";
        ast.name = "Réformé";
        this.assetStatuses.push(ast);

        ast = new AssetStatus();
        ast.assetStatusCode = "Exit";
        ast.name = "Sortie du parc";
        this.assetStatuses.push(ast);
    }

    initEntityContainer() {
        this.entityContainer = new EntityContainer(Asset);
    }

    getRows(): Asset[] {
        return this.assets;
    }

    saveRow(row: Asset): Promise<Asset> {
        return this.assetService.assetSave(row);
    }

  loadData() {

        let assetCode            : string   = null;
        let withLinkedData       : boolean  = true;
        let serialNumber         : string   = this.serialNumber;
        let barCode              : string   = this.barCode;
        let assetOrderCode       : string   = null; 
        let branchCode           : string   = this.branch.branchCode;
        let assetProductCategoryCode  : string   = this.assetProductCategory.assetProductCategoryCode;
        let assetProductCode          : string   = this.assetProduct.assetProductCode;
        let partnerCode          : string   = null;
        let partnerSiteCode      : string   = null;
        let assetStatusCode      : string   =this.assetStatus.assetStatusCode;
        let assetTransferCode    : string   = null;

        this.assetService.assetsGet(
            assetCode            ,
            withLinkedData       ,
            serialNumber         ,
            barCode              ,
            assetOrderCode       , 
            branchCode           ,
            assetProductCategoryCode  ,
            assetProductCode          ,
            partnerCode          ,
            partnerSiteCode      ,
            assetStatusCode      ,
            assetTransferCode    ,
            this.withPendingTickets   ,
            this.withoutPendingTickets,
            this.includeClosed
            ).then(result => {
            this.assets = result;
    
        }).catch(error => {
            this.showError(error);
        })
    }
        
    enrichField(field : Field){
        if ( (field.prop == 'barCode') || (field.prop == 'assetStatusCode')  || (field.prop == 'ticketsNumber') ) {
            field.pipe = this.assetPipe;
            return;
        }
    }

}
